import React, { useState, useEffect } from "react";
import taService from "../services/ta.service";
import { errorToast, successToast } from "../../../../react-toastfiy/toast";
import { rupeesToWords } from "../../../../helpers/functions/rupeesToWords";
import jwtDecode from "jwt-decode";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { 
  getFormDataFromLocalStorage, 
  clearFormDataFromLocalStorage 
} from "../../../../helpers/functions/localStorageHelper";

export default function useLimitSettingDocumentsCollection(active) {
  const { limitData } = active;

  const currentUser = localStorage.getItem("refreshToken");
  const user = jwtDecode(currentUser);
  const history = useHistory();
  
  // Default initial values from limitData
  const defaultInitialValue = {
    date: limitData?.agreementDate,
    creditLimit: limitData?.creditLimit,
    referenceNumber: limitData?.referenceNumber || "",
    amount_in_word: rupeesToWords(limitData?.creditLimit),
    companyName: limitData?.companyName,
    businessType: limitData?.businessType,
    personName: limitData?.personName,
    personPhone : limitData?.taUserPhone,
    pan_no: ["partnership", "pvt_ltd"].includes(limitData?.businessType)
      ? limitData?.firmPan
      : limitData?.userPan,
    address: limitData?.companyAddress,
    cheque_number: "",
    cheque_number_2: "",
    account_no: "",
    branch: "",
    bank_name: "",
    tf_cheque_number: "",
    tf_cheque_number_2: "",
    tf_account_no: "",
    tf_branch: "",
    tf_bank_name: "",
    gstDeclaration: "",
    signature_verification: "",
    otherDocuments: "",
    otherDetails: "",
    cin: "",
    ifsc: "",
    age: "",
    fathersName: "",
    name: limitData?.personName,
    email: limitData?.email,
    ac_holder_name: "",
    // Signature Verification fields for individual business type
    sv_account_holder_name: limitData?.personName,
    sv_account_holder_address: limitData?.companyAddress,
    sv_account_number: "",
    sv_bank_name: "",
    sv_authorized_signatory: limitData?.personName,
    sv_name: limitData?.personName,
    // Signature Verification fields for proprietor business type
    sv_organization_name: limitData?.companyName,
    sv_organization_address: limitData?.companyAddress,
    is_ta_funding_by_mt: limitData?.isTAFundingByMT || false,
    // MT Application Form uses existing fields: personName, companyName, personPhone, email, address
  };

  // Check for draft in local storage - priority: localStorage > limitData
  const savedDraft = getFormDataFromLocalStorage(limitData?.taOnboardingCaseId);
  const initialValue = savedDraft?.formData 
    ? { ...defaultInitialValue, ...savedDraft.formData } 
    : defaultInitialValue;
  
  const [formData, setFormData] = useState(initialValue);
  const [isDraftLoaded, setIsDraftLoaded] = useState(!!savedDraft);
  const [draftTimestamp, setDraftTimestamp] = useState(savedDraft?.timestamp || null);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [selected, setSelected] = useState("offline");
  const [modal, setModal] = useState(false);
  const [documentUploadProgress, setDocumentUploadProgress] = useState(0);
  const [data, setData] = useState();
  const [filterData, setFilterData] = useState();

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setButtonLoader(true);
      const response = await taService.CreateTAUser(formData);
      if (response.status === 200) {
        successToast(response.msg);
        window.location.reload();
      } else {
        errorToast(response.msg);
      }
    } catch (error) {
      console.error(error);
      errorToast(error?.message);
    }
  };

  // Clear draft function
  const clearDraft = () => {
    const cleared = clearFormDataFromLocalStorage(limitData?.taOnboardingCaseId);
    if (cleared) {
      setIsDraftLoaded(false);
      setDraftTimestamp(null);
      // Reset form to default initial values
      setFormData(defaultInitialValue);
      successToast("Draft cleared successfully");
    }
  };

  return {
    selected,
    setSelected,
    formData,
    setFormData,
    buttonLoader,
    setButtonLoader,
    handleSubmit,
    documentUploadProgress,
    setDocumentUploadProgress,
    data,
    setData,
    filterData,
    setFilterData,
    modal,
    setModal,
    user,
    history,
    isDraftLoaded,
    setIsDraftLoaded,
    draftTimestamp,
    clearDraft,
  };
}
